import React, { useState, useEffect, useRef } from 'react';

function getWindowWidth() {
  const { innerWidth: width } = window;
  return width;
}

const Dropdown = ({ label, term, items, index, parentIndex, dispatchFilter, filterQuery = {} }) => {
  const [windowWidth, setWindowWidth] = useState(getWindowWidth());
  const ddElement = useRef();
  const [searchInput, setSearchInput] = useState('');

  useEffect(() => {
    function handleResize() {
      setWindowWidth(getWindowWidth());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isRightAligned = (filterIdx) => {
    const rightAlignedIdx = [];
    if (windowWidth > 639 && windowWidth < 1024) {
      rightAlignedIdx.push(2, 5, 8, 11);
    }
    if (windowWidth > 1023 && windowWidth < 1280) {
      rightAlignedIdx.push(4, 9);
    }
    if (windowWidth > 1279) {
      rightAlignedIdx.push(5, 11);
    }
    return rightAlignedIdx.includes(filterIdx);
  };

  return (
    <ft-dropdown ref={ddElement} full={true} label={label}
                 position={isRightAligned(index) ? 'right' : ''}>
        <ft-icon slot="opener" width="18" name="dropdown" color="gray"></ft-icon>
        <ft-icon slot="closer" width="18" name="close" color="gray"></ft-icon>
      {
        items.length >= 10 ?
          <div className="m-xs">
            <input type="search"
                   onChange={(e) => setSearchInput(e.target.value.toString().trim())}
                   placeholder={Drupal.t('Search Facets')}/>
          </div>
          : ''
      }
      <ul className="dropdown__content-items">
        {
          items
            .filter(({ key }) => key.match(new RegExp(searchInput, 'i')))
            .map(({ key, doc_count, url }, o) => (
              <li key={`option-${parentIndex}${index}${o}`}>
                <label
                  className="flex justify-between gap-2xs items-center w-full py-2xs px-lg"
                  htmlFor={`option-${parentIndex}${index}${o}`}
                >
                  <If condition={url === undefined}>
                    <input id={`option-${parentIndex}${index}${o}`}
                           name={`option-${parentIndex}${index}${o}`}
                           type="checkbox"
                           className="h-4 w-4 rounded border-neutral-lighter"
                           onChange={() => {
                             dispatchFilter({ key, term });
                             ddElement.current.removeAttribute('expanded');
                             setSearchInput('');
                           }}
                           checked={term in filterQuery && filterQuery[term].indexOf(key) > -1}
                    />
                  </If>
                  <Choose>
                    <When condition={url}>
                      <a href={url}>
                        <span className="grow">{key}</span>
                      </a>
                    </When>
                    <Otherwise>
                      <span className="grow">{key}</span>
                    </Otherwise>
                  </Choose>
                  <If condition={doc_count}>
                    <ft-badge type="tag" variant="1">{doc_count}</ft-badge>
                  </If>
                </label>
              </li>
            ))
        }
      </ul>
    </ft-dropdown>
  );
};

export default Dropdown;
